import React from 'react'
import {Link} from "react-router-dom"
import moment from "moment";

function ListCustomerTableItem(props) {
    const {item} = props

    return (
        <tr className="RowItem">
            <td className="itemCol">
                <Link
                    to={{pathname: `list-customers/${item.customerListId}`, search: `?name=${item.customerListName}`}}
                    state={{listName: item.customerListName}}
                >
                    {item.customerListName || ''}
                </Link>
            </td>
            <td className="itemCol"></td>
            <td className="itemCol"></td>
            <td className="itemCol"></td>
            <td className="itemCol">{item.createdAt && moment(item.createdAt).format('DD/MM/YYYY')}</td>
            <td className="itemCol">{item.createdBy}</td>
        </tr>
    )
}

export default ListCustomerTableItem
